import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import Users from "pages/Users/Users";
import MarketplaceUsers from "./MarketplaceUsers";

const AdyenUsers = () => {
  return (
    <Tabs forceRenderTabPanel defaultIndex={0}>
      <TabList className="tabs__list">
        <Tab>Adyen Users</Tab>
        <Tab>Marketplace Users</Tab>
      </TabList>
      <TabPanel>
        <Users />
      </TabPanel>
      <TabPanel>
        <MarketplaceUsers />
      </TabPanel>
    </Tabs>
  );
};
export default AdyenUsers;
